
import { Component, Prop, Vue } from "vue-property-decorator";
import TextInput from "../Reusable/CustomInputs/TextInput.vue";
import Dropdown from "../Reusable/Dropdown/DropdownDragHandle.vue";
import LoadingSpinner from "../Reusable/LoadingSpinner.vue";
import Icon from "../UI/Icon.vue";
import { InlineCompletion } from "@/lib/ai/types";
import CodeInput from "../Reusable/CustomInputs/CodeInput/CodeInput.vue";

@Component({
  components: {
    Icon,
    Dropdown,
    TextInput,
    LoadingSpinner,
    CodeInput
  }
})
export default class InlineAiCompletion extends Vue {
  @Prop({ default: () => ({}) })
  completion!: InlineCompletion;

  @Prop({ default: false })
  cssMode!: boolean;
}
